import Card from "components/card";
import React, { useEffect, useRef, useState } from "react";
import Select from "components/select";
import Modal from "components/modal";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import { ESService } from "services/esService";
import ApiList from "services/apiList";
import InputField from "components/fields/InputField";
import { useNavigate } from "react-router-dom";
import { HiUserAdd } from "react-icons/hi";

const Exam = () => {
  const navigate = useNavigate();
  const mount = useRef(true);
  const [showModal, setShowModal] = useState(false);
  const [examData, setExamData] = useState([]);
  const [teacherData, setTeacherData] = useState();
  const [selectedAttendanceStatus, selectAttendanceStatus] = useState();
  var user = useSelector(currentUser);
  useEffect(() => {
    const getTeacherData = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.teacherData).then((json) => {
        if (json["status"]) {
          setTeacherData(json["data"]);
        }
      });
    };

    const getExamData = () => {
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.examUrl).then((json) => {
        if (json["status"]) {
          setExamData(json["data"]);
        }
      });
    };
    if (mount.current) {
      mount.current = false;
      getTeacherData();
      getExamData();
    }
  }, [user.token]);

  return (
    <>
      <Card extra="p-1 pt-3  flex">
        <div className="relative mb-4 flex items-center justify-between">
          <div className="items-end gap-3 lg:flex "></div>
          <button
            onClick={() => {
              navigate("/admin/exam_detail", { state: { type: "create" } });
            }}
            className={`flex items-center text-xl hover:cursor-pointer ${"bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"} linear justify-center rounded-lg font-bold transition duration-200`}
          >
            <HiUserAdd className="h-6 w-6" />
          </button>
        </div>
        <table className="responsive_table">
          <thead>
            <tr key="ex-header">
              <th>№</th>
              <th>Шалгалтын нэр</th>
              <th>Оноо</th>
              <th>Шалгалтын огноо</th>
              <th>Шалгалт авах анги</th>
            </tr>
          </thead>
          <tbody>
            {examData.map((item, index) => {
              let classData;
              if (teacherData?.schedule_to_detail?.length !== 0) {
                classData = teacherData?.schedule_to_detail?.filter(
                  (value) => item.scheduleDetail === value.id
                );
              }
              return (
                examData.length !== 0 && (
                  <tr key={"ex" + index}>
                    <td data-label="№">
                      {/* {item.id} */}

                      <button
                        onClick={() => {
                          navigate("/admin/exam_detail", {
                            state: { type: "edit", data: item },
                          });
                        }}
                        className="text-blue-800 underline hover:text-blue-600 dark:text-white "
                      >
                        {index + 1}
                      </button>
                    </td>
                    <td data-label="Шалгалтын нэр">{item.exam_name}</td>
                    <td data-label="Огноо">{item.exam_date}</td>
                    <td data-label="Оноо">{item.point}</td>
                    <td data-label="Шалгалт авах анги">
                      {classData &&
                        classData.length !== 0 &&
                        classData[0].lesson.name +
                          "/" +
                          classData[0].course.number +
                          classData[0].course.group}
                    </td>
                  </tr>
                )
              );
            })}
          </tbody>
        </table>
        {showModal && (
          <Modal
            setShowModal={setShowModal}
            className="w-16"
            child={
              <div>
                <p className="text-l text-navy-700 dark:text-white">
                  Шалгалтын нэр
                </p>
                <InputField></InputField>
                <p className="text-l text-navy-700 dark:text-white">Оноо</p>
                <InputField></InputField>

                <Select
                  id="number"
                  value={selectedAttendanceStatus}
                  required={true}
                  label="Төлөв"
                  className="m-1 p-1"
                  defaultText="Огноо сонгоно уу."
                  onChange={(selected) => {
                    selectAttendanceStatus(selected.target.value);
                  }}
                  children={
                    <option key="index" value={"asdf"}>
                      asdf
                    </option>
                  }
                />
              </div>
            }
            title={
              <p className="text-l text-navy-700 dark:text-white">
                Ирц бүртгэх
              </p>
            }
          />
        )}
      </Card>
    </>
  );
};

export default Exam;
